import { useEffect, useState } from 'react'
import { Container, Row, Col, Spinner, Alert, Button } from 'react-bootstrap'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Helmet } from 'react-helmet-async'
import EventList from '../../components/EventList'

const EventsPage = () => {
  return (
    <>
      <Helmet>
        <title>Events - SiberWander</title>
        <meta name="description" content="Join SiberWander's exclusive cybersecurity events, workshops, and training sessions. Stay ahead with the latest insights in cloud security and cybersecurity best practices." />
        <meta name="keywords" content="cybersecurity events, cloud security workshops, training, SiberWander events, security conferences" />
      </Helmet>

      <div className='wrap-hidden'>
        {/* Events Content */}
        <Container className='py-5'>
          <Row>
            <Col xs={12}>
              {/* Active Events with Open Registration */}
              <div className="mb-5">
                <EventList showTitle={true} type="active"/>
              </div>

              {/* Upcoming Events with Closed Registration */}
              <EventList showTitle={true} type="upcoming-closed"/>
            </Col>
          </Row>
        </Container>

        {/* Call to Action Section */}
        <div className='bg-light py-5'>
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="text-center">
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
                  <h3 className='mb-3'>Don't See What You're Looking For?</h3>
                  <p className='mb-4'>
                    We regularly host various cybersecurity events throughout the year. 
                    Contact us to learn about upcoming events or to discuss custom training opportunities for your organization.
                  </p>
                  <div className="d-flex gap-3 justify-content-center flex-wrap">
                    <Button variant="brand" href="/#demo-form">
                      Book a Demo
                    </Button>
                    <Button variant="outline-primary" href="/become-partner">
                      Become a Partner
                    </Button>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Features Section */}
        <Container className='py-5'>
          <Row>
            <Col xs={12}>
              <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
                <div className='header text-center mb-5'>Why Attend Our <span className="text-brand-secondary">Events</span>?</div>
              </AnimationOnScroll>
              
              <Row className="justify-content-center">
                <Col md={6} className="mb-4">
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} offset={100} style={{height:"100%"}}>
                    <div className='card-shadow p-4 text-center h-100'>
                      <div className='mb-3'>
                        <i className="fas fa-graduation-cap text-brand" style={{fontSize: '2.5rem'}}></i>
                      </div>
                      <h5 className='mb-3'>Expert Knowledge</h5>
                      <p className='text-muted'>
                        Learn from industry-leading cybersecurity experts and get hands-on experience with the latest security technologies.
                      </p>
                    </div>
                  </AnimationOnScroll>
                </Col>
                
                <Col md={6} className="mb-4">
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={100} animatePreScroll={true} offset={100} style={{height:"100%"}}>
                    <div className='card-shadow p-4 text-center h-100'>
                      <div className='mb-3'>
                        <i className="fas fa-users text-brand" style={{fontSize: '2.5rem'}}></i>
                      </div>
                      <h5 className='mb-3'>Networking</h5>
                      <p className='text-muted'>
                        Connect with cybersecurity professionals, share experiences, and build valuable relationships in the industry.
                      </p>
                    </div>
                  </AnimationOnScroll>
                </Col>
                
                {/* <Col lg={4} md={6} className="mb-4">
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} delay={200} animatePreScroll={true} offset={100} style={{height:"100%"}}>
                    <div className='card-shadow p-4 text-center h-100'>
                      <div className='mb-3'>
                        <i className="fas fa-certificate text-brand" style={{fontSize: '2.5rem'}}></i>
                      </div>
                      <h5 className='mb-3'>Certification</h5>
                      <p className='text-muted'>
                        Earn valuable certifications and credentials that enhance your professional profile and career prospects.
                      </p>
                    </div>
                  </AnimationOnScroll>
                </Col> */}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default EventsPage